<template>
  <div>
    <v-row class="ma-0 pa-0">
      <!--Data table-->
      <v-col>
        <reportTableDashboard></reportTableDashboard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import reportTableDashboard from "@/pages/admin/components/report/table/reportTableDashboard.vue";
export default {
  components:{
    reportTableDashboard
  },
  data(){
    return {
      
    }
  }
}
</script>